import { createSelector } from 'reselect';

import { selectCartItems } from './selectCartItems';

export const selectIsCartEmpty = createSelector(
    [selectCartItems],
    (items) => !items.some(item => item.quantity > 0),
);
